import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { setWasmUrl } from "@lottiefiles/dotlottie-react";
import dotLottieWasmUrl from "@lottiefiles/dotlottie-web/dotlottie-player.wasm?url";
import App from "./App.tsx";
import "./index.css";
import "./integrations/sentry";
import { PostHogProvider } from "posthog-js/react";

setWasmUrl(dotLottieWasmUrl);

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const POSTHOG_HOST =
  (import.meta.env.VITE_POSTHOG_HOST as string | undefined) || "https://v.omnara.com";
const POSTHOG_UI_HOST =
  (import.meta.env.VITE_POSTHOG_UI_HOST as string | undefined) || "https://us.posthog.com";
const API_BASE_URL =
  (import.meta.env.VITE_API_URL as string | undefined) || "https://api.omnara.com";
const API_HOSTNAME = (() => {
  try {
    return new URL(API_BASE_URL).hostname;
  } catch {
    return undefined;
  }
})();
const withProviders = (node: React.ReactNode) => {
  if (!POSTHOG_KEY) {
    return node;
  }

  return (
    <PostHogProvider
      apiKey={POSTHOG_KEY}
      options={{
        api_host: POSTHOG_HOST,
        ui_host: POSTHOG_UI_HOST,
        debug: import.meta.env.MODE === "development",
        persistence: "localStorage",
        disable_session_recording: import.meta.env.MODE === "development",
        __add_tracing_headers: API_HOSTNAME ? [API_HOSTNAME] : undefined,
      }}
    >
      {node}
    </PostHogProvider>
  );
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>{withProviders(<App />)}</StrictMode>
);

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.error("[PWA] SW registration failed", err);
    });
  });
}
